import { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router'
import { supabase } from '@/lib/supabase'

export default function AuthCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    async function complete() {
      const denied = params.get('error_description')
      if (denied) {
        if (!cancelled) setError(denied)
        return
      }

      const code = params.get('code')

      if (!code) {
        // No code, but a session may already exist — someone re-opened the link
        // in a tab that is already signed in.
        const { data } = await supabase.auth.getSession()
        if (cancelled) return
        if (data.session) {
          navigate('/', { replace: true })
        } else {
          setError('That link is missing its sign-in code. Send yourself a new one.')
        }
        return
      }

      const { error: exchangeError } = await supabase.auth.exchangeCodeForSession(code)
      if (cancelled) return
      if (exchangeError) {
        setError('That link expired or was already used. Send yourself a new one.')
        return
      }

      const next = sessionStorage.getItem('sa:redirect') ?? '/'
      sessionStorage.removeItem('sa:redirect')
      navigate(next, { replace: true })
    }

    void complete()
    return () => {
      cancelled = true
    }
  }, [params, navigate])

  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center px-6">
      {error ? (
        <>
          <p className="eyebrow mb-3">Sign-in failed</p>
          <p className="text-ink mb-6 text-body">{error}</p>
          <Link
            to="/sign-in"
            className="text-mark text-body underline underline-offset-4"
          >
            Back to sign in
          </Link>
        </>
      ) : (
        <p className="eyebrow">Signing you in…</p>
      )}
    </main>
  )
}
